module.exports = __webpack_public_path__ + "img/slideshow-premiere-couverture-lpdm.fb6f9afb.png";